<template>

      <el-form :model="form" :rules="rules" ref="ruleForm" status-icon v-loading="loading" size="small">
        <el-form-item label="考卷标题" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="考卷分类" :label-width="formLabelWidth" prop="lx">
          <el-button type="primary" @click="showlx = !showlx">{{form.lx}}</el-button>
          <transition name="el-fade-in-linear">
            <el-radio-group v-show="showlx" v-model="form.lx">
              <el-radio-button label="公司通知"></el-radio-button>
              <el-radio-button label="事故案例"></el-radio-button>
              <el-radio-button label="操作规程"></el-radio-button>
              <el-radio-button label="专业知识"></el-radio-button>
            </el-radio-group>
          </transition>
        </el-form-item>

      <el-form-item label="关联类型" :label-width="formLabelWidth" prop="glcl">
        <el-select v-model="form.gllx" multiple filterable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="考卷状态" :label-width="formLabelWidth" prop="zt">
          <el-radio-group v-model="form.zt">
            <el-radio-button label="正常" ></el-radio-button>
            <el-radio-button label="草稿"></el-radio-button>
            <el-radio-button label="归档"></el-radio-button>
          </el-radio-group>
      </el-form-item>

      <el-form-item label="考试限时" :label-width="formLabelWidth" prop="time">
        <el-input-number v-model="form.time" controls-position="right" :min="1" :max="100"></el-input-number>
      </el-form-item>

          <el-form-item label="" :label-width="formLabelWidth">
            <el-form-item>
              <el-button size="small" type="primary" :loading="loading" @click="submitForm('ruleForm')">确认提交</el-button>
            </el-form-item>
          </el-form-item>

         <el-form-item label="考卷一览" :label-width="formLabelWidth">
            <el-form-item>
             <tbody v-for="item in form.text">
              <b><font color="red">({{item.ans}})</font>&nbsp&nbsp{{item.id+1}}.{{item.mod}}:{{item.label}}</b>
                <tr v-if="item.mod == '单选题'" v-for="item2 in item.options">
                  &nbsp&nbsp{{item2.value}}.{{item2.label}}
                </tr>
                <p></p>
              </tbody>
            </el-form-item>
          </el-form-item>   

      </el-form>

</template>

<script>
export default {
    data () {
      var checkLx = (rule, value, callback) => {
        if (value === '未分类') {
          callback(new Error('请选择分类'));
        } else {
          callback();
        }
      };
      return {
        addRange:new Array(),
        uploadData:{
          token:'vqgU1wqtfzcZRAniU',
          admin:this.$store.getters.name,
          my:this.$store.getters.token
        },
        showlx:false,
        loading:true,
        form:{
          name:'',
          lx:'请选择文章分类',
          gllx:[],
          gllxname:'',
          text:'',
          zt:'',
          time:10,
          id:this.$route.params.id,
        },
        options:[
            { text: '全部', value: '全部' }, 
            { text: '1类 爆炸品', value: '1类 爆炸品' }, 
            { text: '2类1项 易燃气体', value: '2类1项 易燃气体'}, 
            { text: '2类2项 不燃气体', value: '2类2项 不燃气体' },
            { text: '2类3项 有毒气体', value: '2类3项 有毒气体'}, 
            { text: '3类 易燃液体', value: '3类 易燃液体'}, 
            { text: '4类1项 易燃固体', value: '4类1项 易燃固体'}, 
            { text: '4类2项 自燃物品', value: '4类2项 自燃物品'}, 
            { text: '4类3项 遇湿易燃物品', value: '4类3项 遇湿易燃物品'}, 
            { text: '5类1项 氧化剂', value: '5类1项 氧化剂'},
            { text: '5类2项 有机过氧化物', value: '5类2项 有机过氧化物'},
            { text: '6类1项 毒害品', value: '6类1项 毒害品'},
            { text: '6类2项 感染性物品', value: '6类2项 感染性物品'},
            { text: '7类 放射性物品', value: '7类 放射性物品'},
            { text: '8类 腐蚀品', value: '8类 腐蚀品'},
            { text: '9类 杂类', value: '9类 杂类'},
            { text: '危险废物', value: '危险废物'},
            { text: '普通货物运输', value: '普通货物运输'},
            { text: '旅客运输', value: '旅客运输'}
          ],
        formLabelWidth: '80px',
        rules:{
          name: [
            { required: true, message: '请输入考卷标题', trigger: 'blur' }
          ],
          lx: [
            { validator:checkLx, trigger: 'change' }
          ],
        }
      }
    },
    mounted(){

    },
    methods:{
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message({showClose: true,message: '提交中……'});
            this.editText();
          } else {
            this.$message({showClose: true,message: '请检查内容',type: 'warning'});
            return false;
          }
        });
      },
      editText(){
        this.loading = true;
        var params = new URLSearchParams();
        params.append('token', 'gqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        params.append('name', this.form.name);
        params.append('lx', this.form.lx);
        params.append('gllx', this.form.gllx);
        params.append('zt', this.form.zt);
        params.append('time', this.form.time);
        //params.append('text', this.form.text);
        params.append('id', this.form.id);
        this.$ajax.post("/apis/exam.php",params).then((ret) => {
            console.log(ret);
            this.loading = false;
            if (ret.data == true) {
              //console.log(params);
              this.$message({showClose: true,message: '已修改',type: 'success'});
              this.form.gllxname = String(this.form.gllx);
              this.$store.commit('editExam',this.form);
              this.$router.push('/exam');
              //this.resetForm('ruleForm');
            }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
        });
      },
      getText(){
        var params = new URLSearchParams();
        params.append('token', 'tqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        params.append('id', this.form.id);
        this.$ajax.post("/apis/exam.php",params).then((ret) => {
            // console.log(ret.data);
            this.form.name = ret.data.name;
            this.form.lx = ret.data.lx;
            this.form.gllx = ret.data.gllx == "" ? [] : ret.data.gllx.split(',');
            // console.log(this.form.gllx);
            this.form.gllxname = ret.data.gllx;
            this.form.zt = ret.data.zt;
            this.form.time = ret.data.time;
            this.form.text = JSON.parse(ret.data.text);
            this.$store.commit('editExam',this.form);
            this.loading = false;
            if (ret.data != "token错误" && ret.data != "数据库连接失败") {
            }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
          console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
        });
      }
    },
    components: {

    },
    created(){
      // console.log(this.$store.state.sext[0]);
      var val = this.$store.getters.getExamContent(this.form.id);
      if (val && val.text) {
        this.form = val;
        this.loading = false;
      }
      else this.getText();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select{
  width: 90%;
}
</style>


// WEBPACK FOOTER //
// src/components/Eexam.vue